import { render } from "./SaleSharedExpensesTable.vue?vue&type=template&id=3175f200"
import script from "./SaleSharedExpensesTable.vue?vue&type=script&lang=js"
export * from "./SaleSharedExpensesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__